// 型番の地域から決まる言語（サーバーの card_images.language_of_set_code と同じ）。
// EN・AE（アジアの英語版）→ en、JP → jp。地域の無い古い型番（LOB-001 など）・対応外の地域は null
const REGION_LANG = { JP: 'jp', EN: 'en', AE: 'en' };

export function languageOfSetCode(setCode) {
  const m = /^[A-Z0-9]+-([A-Z]{2})\d/.exec(String(setCode ?? '').trim().toUpperCase());
  return (m && REGION_LANG[m[1]]) ?? null;
}
